import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "../components/Motion";
import { POSTS, CATEGORIES } from "../lib/blog";

export default function Insights() {
  const [active, setActive] = useState("All");
  const list = active === "All" ? POSTS : POSTS.filter((p) => p.category === active);

  return (
    <div data-testid="insights-page" className="pt-32 md:pt-44">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="overline text-[#C19A6B] mb-6">Insights & Frameworks</p>
        <h1 className="font-serif-lux text-[#1A1A1A] text-[13vw] md:text-[8vw] leading-[0.9] tracking-tight">
          <MaskedLines lines={["The playbook", "behind the", "close."]} />
        </h1>
        <p className="font-sans-lux text-[#5C5C5C] mt-8 max-w-xl">
          Field-tested frameworks and buyer's guides on real estate, due diligence, negotiation and market strategy - the same thinking I train my team on.
        </p>

        <div data-testid="insight-filters" className="flex flex-wrap gap-3 mt-12 border-t border-[#E5DFD3] pt-8">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`insight-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setActive(c)}
              className={`px-6 py-3 overline border transition-colors duration-300 ${
                active === c
                  ? "bg-[#1A1A1A] text-[#FDFBF7] border-[#1A1A1A]"
                  : "bg-transparent text-[#5C5C5C] border-[#E5DFD3] hover:border-[#1A1A1A] hover:text-[#1A1A1A]"
              }`}
            >
              {c}
            </button>
          ))}
          <span className="ml-auto self-center font-sans-lux text-sm text-[#5C5C5C]">
            {list.length} {list.length === 1 ? "article" : "articles"}
          </span>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="border-t border-[#E5DFD3]">
          {list.map((post, i) => (
            <Reveal key={post.slug} delay={Math.min(i * 0.03, 0.3)}>
              <Link
                to={`/insights/${post.slug}`}
                data-testid={`insight-post-${post.slug}`}
                className="group grid md:grid-cols-12 gap-6 py-10 border-b border-[#E5DFD3] items-start"
              >
                <div className="md:col-span-3 flex md:flex-col gap-3">
                  <span className="overline text-[#C19A6B]">{post.category}</span>
                  <span className="font-sans-lux text-sm text-[#5C5C5C]">{post.date} · {post.readTime}</span>
                </div>
                <div className="md:col-span-7">
                  <h2 className="font-serif-lux text-3xl md:text-4xl text-[#1A1A1A] tracking-tight leading-[1.08] group-hover:text-[#C19A6B] transition-colors duration-400">
                    {post.title}
                  </h2>
                  {post.excerpt && (
                    <p className="font-sans-lux text-[#5C5C5C] mt-3 leading-relaxed max-w-2xl">{post.excerpt}</p>
                  )}
                </div>
                <div className="md:col-span-2 flex md:justify-end">
                  <span className="w-12 h-12 rounded-full border border-[#E5DFD3] flex items-center justify-center group-hover:bg-[#1A1A1A] group-hover:text-[#FDFBF7] transition-colors duration-400">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
